import React, { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import styles from './styles.module.scss'

interface FAQItem {
    question: string
    answer: string | string[]
}

interface FAQProps {
    title?: string
    items: FAQItem[]
}

const FAQ: React.FC<FAQProps> = ({ title = 'Frequently Asked Questions', items }) => {
    const [openIndex, setOpenIndex] = useState<number | null>(null)

    const toggleQuestion = (index: number) => {
        setOpenIndex(openIndex === index ? null : index)
    }

    const renderAnswer = (answer: string | string[]) => {
        if (Array.isArray(answer)) {
            return (
                <div>
                    <ul className={styles.answerList}>
                        {answer.map((item, idx) => (
                            <li key={idx}>{item}</li>
                        ))}
                    </ul>
                </div>
            )
        }
        return <p className={styles.answerText}>{answer}</p>
    }

    return (
        <section className={styles.faqSection}>
            <div className={styles.container}>
                <h2 className={styles.title}>{title}</h2>
                <div className={styles.faqList}>
                    {items.map((item, index) => (
                        <div key={index} className={`${styles.faqItem} ${openIndex === index ? styles.open : ''}`}>
                            <button
                                className={styles.questionButton}
                                onClick={() => toggleQuestion(index)}
                                aria-expanded={openIndex === index}
                            >
                                <span className={styles.questionText}>{item.question}</span>
                                <ChevronDown className={styles.chevron} size={20} strokeWidth={2.5} />
                            </button>
                            <div className={styles.answerWrapper}>
                                <div className={styles.answerContent}>{renderAnswer(item.answer)}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default FAQ
